import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

const purifier = DOMPurify(window);
purifier.addHook('afterSanitizeAttributes', (node) => {
  if (node.hasAttribute('target')) node.setAttribute('rel', 'noopener noreferrer');
});

@Pipe({
  name: 'htmlSanitizer',
})
export class HtmlSanitizerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const cleanHtml = purifier.sanitize(value ?? '', { ADD_ATTR: ['target'] });
    // Trusted: DOMPurify just removed scripts, event handlers and javascript: URLs, keeping the inline styles and data attributes rich-text comments need.
    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}
